import { Badge } from "@/components/ui/badge"

/**
 * Hero section for the Use Cases listing page.
 * Displays a badge, title, and subtitle with background decorations.
 */
export function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-neutral-900 to-neutral-800 pt-24 pb-16 lg:pt-32 lg:pb-24">
      {/* Background decoration */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute -right-40 bottom-0 h-96 w-96 rounded-full bg-secondary/10 blur-3xl" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:32px_32px]" />
      </div>

      <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <Badge className="mb-6 border-primary/30 bg-primary/10 text-primary">
            Enterprise Use Cases
          </Badge>
          <h1 className="mb-6 text-3xl font-bold text-white sm:text-4xl lg:text-5xl">
            AI Employees for{" "}
            <span className="text-primary">Every Department</span>
          </h1>
          <p className="mx-auto max-w-2xl text-lg text-neutral-400">
            Deploy specialized AI agents that automate workflows across your
            entire organization. Built for the GCC market with deep integrations
            for local systems like ARIS and Qatar Labor Law compliance.
          </p>
        </div>
      </div>
    </section>
  )
}
